import Link from "next/link";
import { useMemo } from "react";
import { ChevronLeft, Flame, History, LayoutDashboard, SearchX, ShoppingBag, Store } from "lucide-react";
import ProductItemSearch from "./ProductItemSearch";
import ImageComponent from "@core/helpers/client/components/image";
import { with_search_query } from "@core/helpers/search-url";

const ContentSearchProduct = ({
    widget,
    search,
    products,
    brands,
    categories,
    search_loading,
    popular_search,
    search_history,
    hasResults,
    set_search_history,
    delete_all_search_history,
    onNavigate = () => { }
}) => {

    const valid_brands = useMemo(() => {
        return brands?.slice(0, 3)
    }, [brands])

    const valid_category = useMemo(() => {

        return categories?.slice(0, 3)

    }, [categories])

    return (
        <div>

            {search?.length > 0 ? (

                search_loading ? (
                    [1, 2, 3].map((i) => (
                        <div
                            key={i}
                            className="w-full h-12 rounded-md overflow-hidden my-3" >
                        </div>
                    ))
                ) : hasResults ? ((

                    <>
                        {/* product */}
                        {products?.length > 0 ?
                            <div className="col-span-1 md:col-span-2">

                                {/* header */}
                                <div className="flex items-center justify-between lg:border-b border-jmt-neutral-200 pb-3">

                                    <div className="flex items-center">
                                        <ShoppingBag size={20} className="text-jmt-primary-900" />
                                        <h3 className="font-bold text-sm text-jmt-main mr-2">محصولات</h3>
                                    </div>

                                    {/* «مشاهده همه» باید نتیجه‌ی همان عبارت جستجو شده را باز
                                        کند (نه صفحه‌ی خالی سرچ) و دراپ‌دان را هم ببندد */}
                                    <Link
                                        href={with_search_query("/search", search)}
                                        onClick={onNavigate}
                                        className="flex items-center text-xs font-bold text-jmt-primary-800 hover:text-jmt-primary-900" >

                                        <span>مشاهده همه</span>
                                        <ChevronLeft size={16} />
                                    </Link>

                                </div>

                                {/* contant */}
                                <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 my-3 [&>.product-search-item:nth-child(n+4)]:hidden
                                [&>.product-search-item:nth-child(4)]:xl:block! [&>.product-search-item:nth-child(n+5)]:xl:hidden">

                                    {products?.map((item, index) => (
                                        <div
                                            key={`products-search-${item?.id ?? index}`}
                                            className="product-search-item"
                                            onClick={onNavigate}>
                                            <ProductItemSearch item={item} search={search} />
                                        </div>
                                    ))}


                                </div>
                            </div>
                            : ""}

                        {/* category & brand */}
                        <div className="col-span-1 md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">

                            {/* category */}
                            {categories?.length > 0 ?

                                <div>

                                    {/* header */}
                                    <div className="flex items-center lg:border-b border-jmt-neutral-200 pb-3">
                                        <LayoutDashboard size={20} className="text-jmt-primary-900" />
                                        <h3 className="font-bold text-sm text-jmt-main mr-2">دسته‌بندی</h3>
                                    </div>

                                    {/* contant */}
                                    {valid_category?.map((item, index) => (
                                        <div key={`categories-search-${item.id}`} onClick={() => { set_search_history({ ...item, link: item?.seo_full_url }); onNavigate(); }}>
                                            <Link
                                                href={with_search_query(item?.seo_full_url, search)}
                                                className="flex items-center text-jmt-neutral-700 hover:text-jmt-primary-800 pt-3 transition" >
                                                <h3 className="text-[13px]">
                                                    {item?.title}
                                                </h3>
                                            </Link>
                                        </div>
                                    ))}

                                </div>
                                : ""}


                            {/* brand */}
                            {brands?.length > 0 ?
                                <div>

                                    {/* header */}
                                    <div className="flex items-center lg:border-b border-jmt-neutral-200 pb-3">
                                        <Store size={20} className="text-jmt-primary-900" />
                                        <h3 className="font-bold text-sm text-jmt-main mr-2">برند</h3>
                                    </div>

                                    {/* contant */}
                                    {valid_brands?.map((item, index) => (
                                        <div key={`brands-search-${item.id}`} onClick={() => { set_search_history({ ...item, link: item?.seo_full_url }); onNavigate(); }}>
                                            <Link
                                                href={with_search_query(item?.seo_full_url, search)}
                                                className="flex items-center text-jmt-neutral-700 hover:text-jmt-primary-800 pt-3 transition" >
                                                <h3 className="text-[13px]">
                                                    {item?.title}
                                                </h3>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                                : ""}

                        </div>

                    </>
                )) :
                    <>
                        {/* no result */}
                        <div className="">

                            <div className="w-full flex items-center justify-center gap-2 mb-3">
                                <SearchX size={20} className="text-jmt-neutral-600" />

                                <h3 className="text-sm font-bold text-jmt-neutral-600">
                                    نتیجه ایی برای "{search}" یافت نشد
                                </h3>
                            </div>

                            {/* history search */}
                            {search_history?.length > 0 ?
                                <div className="mb-6">
                                    {/* header */}
                                    <div className="flex items-center justify-between mb-3">
                                        <div className="flex items-center gap-1">
                                            <History size={20} className="text-jmt-primary-900" />
                                            <h3 className="text-sm font-bold text-jmt-main">  جستجوهای اخیر  </h3>
                                        </div>
                                        <span className="text-jmt-neutral-500 text-xs font-bold cursor-pointer hover:text-jmt-primary-800"
                                            onClick={delete_all_search_history}> پاک کردن همه </span>
                                    </div>

                                    {/* content */}
                                    <div className="flex flex-wrap gap-2">
                                        {search_history?.map((item, i) => (
                                            <Link
                                                href={item?.seo_full_url || ""}
                                                key={i}
                                                className="px-4 py-1.5 border border-jmt-neutral-200 rounded-md text-[13px] text-jmt-neutral-700 hover:border-jmt-primary-800 transition" >
                                                {item.title}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                                : ""}

                            {/* popular search */}
                            {popular_search?.length > 0 ?
                                <div>
                                    {/* header */}
                                    <div className="flex items-center gap-1 mb-3">
                                        <Flame size={20} className="text-jmt-primary-900" />
                                        <h3 className="text-sm font-bold text-jmt-main">   جستجوهای محبوب </h3>
                                    </div>

                                    {/* content */}
                                    <div className="flex flex-wrap gap-2">
                                        {popular_search?.map((item, i) => (
                                            <Link
                                                href={item?.link?.url || ""}
                                                key={i}
                                                className="px-4 py-1.5 border border-jmt-neutral-200 rounded-md text-[13px] text-jmt-neutral-700 hover:border-jmt-primary-800 transition" >
                                                {item.title}
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                                : ""}

                        </div>
                    </>
            ) : (

                <>
                    {/* gif */}
                    {widget?.fields?.gif?.url ?
                        <div className="w-full h-30 rounded-md overflow-hidden mb-6">
                            <ImageComponent
                                src={widget?.fields?.gif?.url || ""}
                                alt={widget?.fields?.gif?.alt || ""}
                                width={100}
                                height={100}
                                style={{ width: "100%", height: "100%" }}
                                image_className="object-cover"
                            />
                        </div> : ""}

                    {/* history search */}
                    {search_history?.length > 0 ?
                        <div className="mb-6">
                            {/* header */}
                            <div className="flex items-center justify-between mb-3">
                                <div className="flex items-center gap-1">
                                    <History size={20} className="text-jmt-primary-900" />
                                    <h3 className="text-sm font-bold text-jmt-main">  جستجوهای اخیر  </h3>
                                </div>
                                <span className="text-jmt-neutral-500 text-xs font-bold cursor-pointer hover:text-jmt-primary-800"
                                    onClick={delete_all_search_history}> پاک کردن همه </span>
                            </div>

                            {/* content */}
                            <div className="flex flex-wrap gap-2">
                                {search_history?.map((item, i) => (
                                    <Link
                                        href={item?.seo_full_url || ""}
                                        key={i}
                                        className="px-3 lg:px-4 py-1.5 border border-jmt-neutral-200 rounded-md text-[13px] text-jmt-neutral-700 hover:border-jmt-primary-800 transition" >
                                        {item.title}
                                    </Link>
                                ))}
                            </div>
                        </div>
                        : ""}

                    {/* popular search */}
                    {popular_search?.length > 0 ?
                        <div>
                            {/* header */}
                            <div className="flex items-center gap-1 mb-3">
                                <Flame size={20} className="text-jmt-primary-900" />
                                <h3 className="text-sm font-bold text-jmt-main">   جستجوهای محبوب </h3>
                            </div>

                            {/* content */}
                            <div className="flex flex-wrap gap-2">
                                {popular_search?.map((item, i) => (
                                    <Link
                                        href={item?.link?.url || ""}
                                        key={i}
                                        className="px-3 lg:px-4 py-1.5 border border-jmt-neutral-200 rounded-md text-[13px] text-jmt-neutral-700 hover:border-jmt-primary-800 transition" >
                                        {item.title}
                                    </Link>
                                ))}
                            </div>
                        </div>
                        : ""}

                </>
            )}

        </div>
    );
};
export default ContentSearchProduct
